const TEXT_TABLE_SELECTOR = '.sl-block > div > div[style*="display: table"]';
const authoredStyles = new WeakMap<HTMLElement, string>();

export function pinAuthoredTextLines(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>(TEXT_TABLE_SELECTOR).forEach((table) => {
    const box = table.parentElement;
    const cell = table.firstElementChild;
    if (!box || !(cell instanceof HTMLElement)) return;

    const saved = authoredStyles.get(table);
    const authoredStyle = saved ?? table.getAttribute("style") ?? "";
    if (saved === undefined) authoredStyles.set(table, authoredStyle);
    else table.setAttribute("style", authoredStyle);

    const boxHeight = box.clientHeight;
    const wrappedHeight = cell.offsetHeight;
    if (wrappedHeight <= boxHeight) return;

    const style = getComputedStyle(table);
    const lineHeight = parseFloat(style.lineHeight);
    if (!Number.isFinite(lineHeight)) return;

    table.style.whiteSpace = "pre";
    const pinnedHeight = cell.offsetHeight;
    const overflow = table.offsetWidth - box.clientWidth;

    const pinnedFits =
      pinnedHeight < wrappedHeight &&
      pinnedHeight <= boxHeight + lineHeight / 2 &&
      overflow <= lineHeight;
    if (!pinnedFits) {
      table.setAttribute("style", authoredStyle);
      return;
    }

    if (overflow <= 0) return;
    const align = style.textAlign;
    const shift =
      align === "center"
        ? overflow / 2
        : align === "right" || align === "end"
          ? overflow
          : 0;
    if (shift > 0) table.style.marginLeft = `${-shift}px`;
  });
}
